import { render, staticRenderFns } from "./FacStore.vue?vue&type=template&id=dbbedf46"
import script from "./FacStore.vue?vue&type=script&lang=js"
export * from "./FacStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports